// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2944":"df74cb28","4295":"06d893c4","4393":"57652a0b","6598":"6139b19d","9569":"1bf7808e","9707":"06d893c4"}[chunkId] + ".chunk.css";
};